module.exports = __webpack_public_path__ + "img/angles-up.6df772cc.svg";